import React from "react";
import { MemberManager } from "@/components/admin/MemberManager";

export default function MembersPage() {
    return (
        <div className="max-w-6xl mx-auto">
            <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-slate-900 to-slate-600">Active Team Directory</h1>
                <p className="text-slate-500 mt-2 font-medium">Manage your organization&apos;s active members, manage roles, and handle offboarding.</p>
            </div>

            <MemberManager />
        </div>
    );
}
